<script>
	import MetisMenu from "metismenujs/dist/metismenujs";
	import AddButton from './buttons/AddButton.vue';
	import FormSwitchCheckbox from "./forms/FormSwitchCheckbox.vue";
	import SpinnerLoader from "./loaders/SpinnerLoader.vue";

	/**
	 * Side-nav component
	 */
	export default {
  components: { AddButton, FormSwitchCheckbox, SpinnerLoader },
    mounted: function () {
        // eslint-disable-next-line no-unused-vars
        var menuRef = new MetisMenu("#side-menu");
    },
    computed: {
		// Example 1,2,3,4
        userType() {
            return this.$page.props.auth.user.user_type;
        },
        // Example admin,sb.tc,tp
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        // Example Admin, Enterprise Partner, Tax Company, Tax Payer
        userTypeText() {
            return this.$page.props.auth.user.user_type_text;
        },
        // Example Admin, Enterprise Partner, Tax Company, Tax Payer
        userPermissions() {
            return this.$page.props.auth.user.user_permission;
        },
        isLockedAcc() {
            return this.$page.props.auth.user.is_it_locked_account;
        },
        isPaidAcc() {
            return this.$page.props.auth.user.login_user_is_paid;
        },
		customResources() {
			return this.$page.props.auth.user.custom_resources_sidebar;
		},
		resourceTypes() {
			return this.$page.props.auth.user.resource_types;
		},
		commonResources() {
			return this.$page.props.auth.user.common_resources;
		},
		teamOrOE() {
			if(this.$page.props.auth.user.user_type == 1) {
				if(this.loginAccIsEmployed)
					return 'Teammates'
				else
					return 'Teammates & Ultra Admin'
			} else {
				return 'Office Executives'
			}
		},
		loginAccIsEmployed() {
			return this.$page.props.auth.user.session_is_employed;
		},
		isOeLogin() {
			return this.$page.props.auth.user.is_oe_login;
		},
		adminToUltraAdmin() {
			return this.$page.props.auth.user.admin_to_ultra_admin
		},
		adminToSb() {
			return this.$page.props.auth.user.admin_to_sb;
		},
		adminToTc() {
			return this.$page.props.auth.user.admin_to_tc;
		},
		epToTc() {
			return this.$page.props.auth.user.ep_to_tc;
		},
		tcToTp() {
			return this.$page.props.auth.user.tc_to_tp;
		},
		adminToTp() {
			return this.$page.props.auth.user.admin_to_tp;
		},
		activeDashboard() {
			return this.$page.component === 'views/Dashboard' || this.$page.component === 'views/tp/Dashboard' ? true : false;
		},
		activeClientMangementEp() {
			return this.$page.component === 'views/client-management/admin/EnterprisePartnerCMVPage' ? true : false;
		},
		activeClientMangementTc() {
			return this.$page.component === 'views/client-management/admin/TaxCompanyCMVPage' || this.$page.component === 'views/client-management/enterprise-partner/TaxCompanyCMVPage' ? true : false
		},
		activeClientMangementTp() {
			return this.$page.component === 'views/client-management/admin/TaxPayerCMVPage' || this.$page.component === 'views/client-management/enterprise-partner/TaxPayerCMVPage' ? true : false;
		},
		activeClientMangementAll() {
			return this.$page.component === 'views/client-management/admin/AllTypesCMVPage' || this.$page.component === 'views/client-management/enterprise-partner/AllTypesCMVPage' ? true : false;
		},
		activeTcClientManagement() {
			return this.$page.component === 'views/client-management/tax-company/TaxPayerCMVPage' ? true : false
		},
		taxSoftwareURL() {
			return this.$page.props.auth.user.header_tax_software_url;
		},
		taxSoftwareResourceName() {
			return this.$page.props.auth.user.header_tax_software_resource_name;
		},
		activeDocumentManager() {
			return this.$page.component === 'views/document-manager/DocumentManagerPage.vue' || this.$page.component === 'views/document-manager/SharedDocumentManagerPage.vue' || this.$page.component === 'views/document-manager/DocumentManagerFolderContentPage.vue' || this.$page.component === 'views/document-manager/DocumentManagerSharedFolderContentPage.vue' || this.$page.component === 'views/document-manager/components/Trash' ? true : false;
		},
		activeOwnDocumentManager() {
			return this.$page.component === 'views/document-manager/DocumentManagerPage.vue' || this.$page.component === 'views/document-manager/DocumentManagerFolderContentPage.vue' ? true : false;
		},
		activeSharedDocumentManager() {
			return this.$page.component === 'views/document-manager/SharedDocumentManagerPage.vue' || this.$page.component === 'views/document-manager/DocumentManagerSharedFolderContentPage.vue' ? true : false;
		},
		activeWorkflowManagement() {
			return this.$page.component === 'views/workflow-management/Index.vue' ? true : false;
		},
		activeOnboarding() {
			return this.$page.component === 'views/onboarding-checklist/Index.vue' ? true : false;
		},
		activeOfficeManagement() {
			return this.$page.component === 'views/office-hours-management/Index.vue' ? true : false;
		},
		activeTeammate() {
			return this.$page.component === 'views/ultra-admin/Index.vue' ? true : false;
		},
		isUltraAdmin() {
			return this.$page.props.auth.user.is_ultra_admin
		},
		isNeedToOpenTutorialVideo: {
			get: function () {
				return this.$page.props.auth.user.isNeedToOpenTutorialVideo
			},
			// setter
			set: function (newValue) {
				this.$page.props.auth.user.isNeedToOpenTutorialVideo = newValue
			}
		},
		messageSidebarText() {
			return this.userType != 4 ? 'Messages' : 'Communication'
		},
		calendarRoute() {
			return this.userType != 4 ? route(this.userTypeAbbr + '-calendar') : route('tp-schedule')
		},
		invoiceSidebarText() {
			return this.userType != 4 ? 'Invoices' : 'Billing'
		},
		activeProfile() {
			return this.$page.component === 'views/profile/Index' ? true : false
		}
    },
	data() {
		let twoStepStatus = this.$page.props.auth.user.isAllowTwoStepVerification
		return {
			twoStepVerificationStatus: twoStepStatus
		}
	},
	methods: {
		handleTwoStepVerification(event) {
			this.isStatusActiveInactiveLoading = true
			let status = 0;
			let statusMsg = 'Inactive two step verification!'
			if(event) {
				status = 1;
				statusMsg = 'Active two step verification!'
			}
			this.$inertia.post(
				route('admin-active-inactive-two-step-verification'),
				{
					"mydata" : {
						status: status,
						platform: 'Vue'
					}
				},
				{
					onSuccess: (response) => {
						this.$toastr.s(statusMsg)
					},
					onError: (errors) => {
						if(errors.message) {
							this.$toastr.e(errors.message)
						}
					}
				}
			)
		},
		updateTutorial() {
			this.$inertia.post(
				route('update_welcome_modal_tutorial'),
				{
					'data' : 1
				},
				{
					onError: (errors) => {
						if(errors.message) {
							this.$toastr.e(errors.message);
						}
					}
				}
			)
		}
	}
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
	<!--- Sidemenu -->
	<div id="sidebar-menu">
		<!-- Left Menu Start -->
		<ul id="side-menu" class="metismenu list-unstyled">
			<li class="d-sm-none">
				<a target="_blank" :href="taxSoftwareURL">
					<button type="button" class="btn btn-success w-lg waves-effect waves-light">
						{{taxSoftwareResourceName}}
					</button>
				</a>
			</li>
			<li :class="{'mm-active': activeDashboard}">
				<Link :href="route('home_page')" class="waves-effect" :class="{'active': activeDashboard}">
					<i class="bx bx-home-circle"></i>
					<span key="t-dashboard">Dashboard</span>
				</Link>
			</li>
			<template v-if="userType != 4">
				<li v-if="userType != 3" :class="{'mm-active': activeClientMangementEp || activeClientMangementTc || activeClientMangementTp || activeClientMangementAll}">
					<a href="javascript: void(0);" class="has-arrow waves-effect" :class="{'mm-active': activeClientMangementEp || activeClientMangementTc || activeClientMangementTp || activeClientMangementAll}">
						<i class="bx bxs-user-detail"></i>
						<span key="t-client_management">Client Management</span>
					</a>
					<ul class="sub-menu" aria-expanded="false">
						<!-- For user-type 1 -->
						<template v-if="userType == 1">
							<li v-if="!userPermissions || userPermissions.ep_clients  || userPermissions.other_oe_ep_clients" :class="{'mm-active': activeClientMangementEp}">
								<Link :href="route('admin-sb-list')" key="t-enterprise_partners" :class="{'active': activeClientMangementEp}">
									Enterprise Partners
								</Link>
							</li>
							<li v-if="!userPermissions || userPermissions.tc_clients  || userPermissions.other_oe_tc_clients" :class="{'mm-active': activeClientMangementTc}">
								<Link :href="route('admin-tc-list')" key="t-Tax_Companies" :class="{'active': activeClientMangementTc}">
									Tax Companies
								</Link>
							</li>
							<li v-if="!userPermissions || userPermissions.tp_clients  || userPermissions.other_oe_tp_clients" :class="{'mm-active': activeClientMangementTp}">
								<Link :href="route('admin-tp-list')" key="t-Tax_Payers" :class="{'active': activeClientMangementTp}">
									Tax Payers
								</Link>
							</li>
						</template>			
						<template v-if="userType == 2">
							<!-- For user-type 2 -->
							<li v-if="!userPermissions || userPermissions.tc_clients || userPermissions.other_oe_tc_clients" :class="{'mm-active': activeClientMangementTc}">
								<Link :href="route('sb-tc-list')" key="t-Tax_Companies" :class="{'active': activeClientMangementTc}">
									Tax Companies
								</Link>
							</li>			
							<li v-if="!userPermissions || userPermissions.tp_clients" :class="{'mm-active': activeClientMangementTp}">
								<Link :href="route('sb-tp-list')" key="t-Tax_Payers" :class="{'active': activeClientMangementTp}">
									Tax Payers
								</Link>
							</li>
						</template>
						<!-- For user-type 1, 2 -->
						<li :class="{'mm-active': activeClientMangementAll}">
							<Link :href="route(userTypeAbbr + '-contacts')" key="t-All_Clients" :class="{'active': activeClientMangementAll}">
								All Clients
							</Link>
						</li>  
					</ul>
				</li>
				<li v-else :class="{'mm-active': activeTcClientManagement}">
					<Link :href="route(userTypeAbbr + '-contacts')" class="waves-effect" :class="{'active': activeTcClientManagement}">
						<i class="bx bxs-user-detail"></i>
						<span key="t-client_management">Client Management</span>
					</Link>
				</li>
				<template v-if="!isLockedAcc && isPaidAcc">
					<li v-if="(!userPermissions || userPermissions.email_blast) && !isUltraAdmin">
						<a :href="route(userTypeAbbr + '-campaign-list')" class="waves-effect">
							<i class="bx bx-envelope"></i>
							<span key="t-Email_Campaigns">Email Campaigns</span>
						</a>
					</li>
				</template>
			</template>
			<template v-else>
				<li>
					<a :href="route('tp-organizer')" class="waves-effect">
						<i class="bx bxs-info-circle"></i>
						<span key="t-Messages">Client Organizer</span>
					</a>
				</li>
			</template>
			<template v-if="!isLockedAcc && isPaidAcc">
				<li v-if="!userPermissions || userPermissions.communications || userPermissions.sms_portal">
					<a :href="route(userTypeAbbr + '-communications')" class="waves-effect">
						<i class="bx bx-chat"></i>
						<span key="t-Messages"> {{ messageSidebarText }} </span>
					</a>
				</li>
			</template>
			<template v-if="!userPermissions || userPermissions.doc_mngr">
				<li :class="{'mm-active': activeDocumentManager}">
					<a :href="route(userTypeAbbr + '-document-manager')" class="waves-effect" :class="{'mm-active': activeDocumentManager}">
						<i class="bx bx-file"></i>
						<span key="t-Document_Manager">Document Manager</span>
					</a>
					<!-- <ul class="sub-menu" aria-expanded="false"> -->
						<!-- <li :class="{'mm-active': activeOwnDocumentManager}">
							<Link :href="route(userTypeAbbr + '-document-manager')" key="t-my-Folders" :class="{'active': activeOwnDocumentManager}">My Folders</Link>
						</li>
						<li :class="{'mm-active': activeSharedDocumentManager}">
							<Link :href="route(userTypeAbbr + '-shared-document-manager')" key="t-shared-Folders" :class="{'active': activeSharedDocumentManager}">Shared Folders</Link>
						</li> -->
					<!-- </ul> -->
				</li>
				<li v-if="userType != 4 && !isLockedAcc && isPaidAcc">
					<a :href="route(userTypeAbbr + '-e-signature-list')" class="waves-effect">
						<i class="bx bx-pencil"></i>
						<span key="t-E-Signatures">E-Signatures</span>
					</a>
				</li>
			</template>
			<li v-if="userType == 4 && !isLockedAcc">
				<a :href="route(userTypeAbbr + '-e-signature-list')" class="waves-effect">
					<i class="bx bx-pencil"></i>
					<span key="t-E-Signatures">E-Signatures</span>
				</a>
			</li>
			<template v-if="!isLockedAcc && isPaidAcc && !isUltraAdmin">
				<li v-if="!userPermissions || userPermissions.task_management">
					<a :href="route(userTypeAbbr + '-task_management_index')" class="waves-effect">
						<i class="bx bx-task"></i>
						<span key="t-task_Management">Task Management</span>
					</a>
				</li>
				<li :class="{'mm-active': activeWorkflowManagement}" v-if="(userType == 2 || userType == 3) && (!userPermissions || userPermissions.workflow_management)">
					<Link :href="route(userTypeAbbr + '-workflow-management.index')" class="waves-effect"  :class="{'active': activeWorkflowManagement}">
						<i class="bx bx-task"></i>
						<span key="t-workflow_Management">Workflow Management</span>
					</Link>
				</li>
			</template>
			<template v-if="!isLockedAcc && isPaidAcc">
				<li v-if="(!userPermissions || userPermissions.calendar) && !isUltraAdmin">
					<a :href="calendarRoute" class="waves-effect">
						<i class="bx bx-calendar"></i>
						<span key="t-Schedule">Schedule</span>
					</a>
				</li>
				<li v-if="!userPermissions || userPermissions.invoices">
					<a :href="route(userTypeAbbr + '-invoice')" class="waves-effect">
						<i class="bx bx-receipt"></i>
						<span key="t-Invoices">
							{{ invoiceSidebarText }}
						</span>
					</a>
				</li>
			</template>
			<template v-if="userType !=4 && !isLockedAcc && isPaidAcc">
				<template v-if="(!userPermissions || userPermissions.resources || userPermissions.projections) && !isUltraAdmin">
					<li>
						<a href="javascript: void(0);" class="has-arrow waves-effect">
							<i class="bx bx-share-alt"></i>
							<span key="t-Resources">Resources</span>
						</a>
						<ul class="sub-menu" aria-expanded="false">
							<template v-if="!userPermissions || userPermissions.resources">
								<template v-for="(item, index) of resourceTypes">
									<li v-if="commonResources[index] && commonResources[index].is_active && !commonResources[index].is_trash && commonResources[index].url.length > 0" :key="item.id">
									<a :href="commonResources[index].url" key="t-{{ item.resource_name }}" target="_blank">
										{{ item.resource_name }}</a>
									</li>
									<li v-else :key="item.id"><a href="javascript:void(0)" onclick="alert('The resource is currently inactive!');" key="t-{{ item.resource_name }}">{{ item.resource_name }}</a></li>
								</template>
								<template v-for="item of customResources">
									<li v-if="item.is_active" :key="item.id">
									<a :href="item.url" key="t-{{ item.resource_name }}" target="_blank">
										{{ item.resource_name }}</a>
									</li>
								</template>
							</template>								
							<li v-if="!userPermissions || userPermissions.projections"><a :href="route(userTypeAbbr + '-projections')" target="_blank" key="t-Revenue_Calculator">Revenue Calculator</a></li>
						</ul>
					</li>
				</template>
			</template>
			<li v-if="userType == 4 && !isLockedAcc" :class="{'mm-active': activeProfile}">
				<Link :href="route(userTypeAbbr + '-profile-edit')" class="waves-effect" :class="{'active': activeProfile}">
					<i class="bx bx-user"></i>
					<span key="t-Profile">Profile</span>
				</Link>
			</li>
			<li :class="{'mm-active': activeOnboarding || activeOfficeManagement || activeTeammate}">
				<a href="javascript: void(0);" class="has-arrow waves-effect" :class="{'mm-active': activeOnboarding || activeOfficeManagement || activeTeammate}">
					<i class="bx bx-cog"></i>
					<span key="t-Settings">Settings</span>
				</a>
				<ul class="sub-menu" aria-expanded="false">
					<template v-if="userType != 4 && !isLockedAcc && isPaidAcc">
						<li><a :href="route(userTypeAbbr + '-profile')" key="t-Profile">Profile</a></li>
						<li v-if="userType == 2 || userType == 3"><a href="Javascript:void(0)" key="t-Tutorial" @click="$page.props.auth.user.isNeedToOpenTutorialVideo = true" >Tutorial</a></li>
						<li v-if="userType != 4 && !isUltraAdmin" :class="{'mm-active': activeTeammate}">
							<a :href="route(userTypeAbbr + '-office-executives')" key="t-Office_Executives" :class="{'active': activeTeammate}">
								{{teamOrOE}}
							</a>
						</li>
					</template>
					<li v-if="!loginAccIsEmployed && (userType == 2 || userType == 3)"><a :href="route(userTypeAbbr + '-billing')" key="t-Payment">Payment</a></li>
					<li v-if="userType == 1 && !isUltraAdmin"><a :href="route('admin-reports')" key="t-Reports">Reports</a></li>
					<li v-else-if="userType == 2"><a :href="route('sb-reports')" key="t-Reports">Reports</a></li>
					<li v-else-if="userType == 3 && !isLockedAcc && isPaidAcc"><a :href="route('tc-reports')" key="t-Reports">Reports</a></li>
					<li v-if="userType == 2 && !loginAccIsEmployed" :class="{'mm-active': activeOnboarding}">
						<Link :href="route('sb-onboarding-checklist-items-index')" key="t-onboarding" :class="{'active': activeOnboarding}">Onboarding Checklist</Link>
					</li>
					<li v-if="userType != 4 && !isLockedAcc && isPaidAcc" :class="{'mm-active': activeOfficeManagement}">
						<Link :href="route(userTypeAbbr + '-office-hours-management')" key="t-office-hours" :class="{'active': activeOfficeManagement}">Office Hours Management</Link>
					</li>
					<template v-if="!isLockedAcc && isPaidAcc">
						<li v-if="(!userPermissions || userPermissions.sms_portal) && userType != 4">
						<a :href="route(userTypeAbbr + '-sms-contacts')" key="t-SMS_Contacts">SMS Contacts</a></li>
						<li><a :href="route(userTypeAbbr + '-templates')" key="t-Messages_Templates">Messages Templates</a></li>
					</template>
					<template v-if="userType == 1">
						<li v-if="isOeLogin">
							<a :href="route('admin-move-back-to-employer')" key="t-Back_to_Employer">Back to Employer</a>
						</li>
						<li v-if="adminToUltraAdmin">
							<a :href="route('ultra-admin-move-back-to-admin')" key="t-Back_to_Employer">Back to Admin</a>
						</li>
					</template>
					<li v-if="userType == 1 && isOeLogin"><a :href="route('admin-move-back-to-employer')" key="t-Back_to_Employer">Back to Employer</a></li>
					<template v-if="userType == 2">
						<li v-if="isOeLogin"><a :href="route('sb-move-back-to-employer')" key="t-Back_to_Employer">Back to Employer</a></li>
						<li v-if="adminToSb"><a :href="route('move-sb-to-admin')" key="t-Back_to_Admin">Back to Admin</a></li>
					</template>
					<template v-if="userType == 3">
						<li v-if="isOeLogin"><a :href="route('tc-move-back-to-employer')" key="t-Back_to_Employer">Back to Employer</a></li>
						<li v-if="adminToTc"><a :href="route('move-tc-to-admin')" key="t-Back_to_Admin">Back to Admin</a></li>
						<li v-if="epToTc"><a :href="route('move-tc-to-ep')" key="t-Back_to_EnterprisePartner">Back to Enterprise Partner</a></li>
					</template>
					<template v-if="userType == 4">
						<li v-if="tcToTp"><a :href="route('move-tp-to-tc')" key="t-Back_to_TaxCompany">Back to Tax Company</a></li>
						<li v-if="adminToTp"><a :href="route('move-tp-to-admin')" key="t-Back_to_Admin">Back to Admin</a></li>
					</template>
					<template v-if="userType == 1 && !loginAccIsEmployed && !isUltraAdmin">
						<li>
							<a href="Javascript:void(0)" title="Allow Two Step Verification" key="t-twoStepVerification">
								<FormSwitchCheckbox id="twoStepVerification" v-model="twoStepVerificationStatus" name="twoStepVerification" :label="twoStepVerificationStatus ? 'OTP Enabled' : 'OTP Disabled'" @input="handleTwoStepVerification($event)" />
							</a>
						</li>
					</template>
					<li><a :href="route('session-logout')" key="t-Log_Out">Log Out</a></li>
				</ul>
			</li>
		</ul>
		<b-modal 
			v-model="isNeedToOpenTutorialVideo"
			hide-footer centered 
			header-class="border-0" 
			title="Adding New Clients"
			@hidden="updateTutorial"
			:no-close-on-backdrop="true"
		>
			<div class="row">
				<div class="col-12">
					<video width="470" height="250" controls>
						<source src="/public/demo_files/new_client_narration.mp4" type="video/mp4">
					</video> 
				</div>
			</div>
		</b-modal>
  	</div>
  <!-- Sidebar -->
</template>
